import { Outlet } from "react-router-dom"
import { AnimatePresence, motion } from "framer-motion"
import { useLocation } from "react-router-dom"
import { AnimatedOrbs } from "@/components/layout/AnimatedOrbs"

export function PublicLayout() {
  const location = useLocation()

  return (
    <div className="relative min-h-screen overflow-hidden bg-[var(--base,#f0f4ff)]">
      <AnimatedOrbs />

      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          className="relative z-10 flex min-h-screen items-center justify-center px-4 py-8"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
    </div>
  )
}
